export default "__VITE_ASSET__Rtqw7PAB__"